// extracted by mini-css-extract-plugin
module.exports = {"loader":"ya","smallLoader":"za","loading-keyframes":"Aa","pageLoader":"Ba","centered":"Ca","whitespacePlaceholder":"Da","buttonSpinner":"Ea","fade-in":"Fa","rotate":"Ga"};